document.addEventListener('DOMContentLoaded', () => {
    const CATEGORY_DIGITAL_CURRENCY_NEWS_SELECTOR = '.category-digital-currency-news';

    const addClassForRowsWithLessTd = () => {
        const tables = document.querySelectorAll('table');

        if (tables.length === 0) return;

        tables.forEach((table) => {
            if (table.closest(CATEGORY_DIGITAL_CURRENCY_NEWS_SELECTOR)) return;

            const rows = Array.from(table.querySelectorAll('tbody tr'));
            const maxCells = Math.max(...rows.map((row) => row.children.length));

            rows.forEach((tr) => {
                const cellCount = tr.children.length;
                if (cellCount < maxCells) {
                    tr.classList.add('table-row-has-less-td');
                }
            });
        });
    };

    addClassForRowsWithLessTd();
});
